<template>
  <div class="detailBox">
    <div
      style="position: absolute; z-index: 400;"
      :style="{
        left: form.x + 52 + 'px',
        top: form.y - 120 + 'px'
      }"
      class="content-box"
    >
      <div class="warn">
        <div class="title">{{ form.name }}</div>
        <ul class="list-box">
          <li class="list-li" v-for="(item, i) in form.dataList" :key="i">
            <span class="point"></span>
            {{ item.name }}：
            <span :class="checkNumber(item.num) ? 'num' : ''">{{
              item.num
            }}</span>
            <span class="unit" v-show="item.unit">({{ item.unit }})</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// 种植大户 信息卡
export default {
  props: {
    form: Object
  },
  data() {
    return {};
  },

  methods: {
    checkNumber(theObj) {
      var reg = /^[0-9]+.?[0-9]*$/;
      if (reg.test(theObj)) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.detailBox
  z-index 10
  color #fff
.content-box
    :before
        width 52px
        height 66px
        content ''
        position absolute
        top 20%
        left 0
        margin-left -52px
        background url('~images/map/task-line.png') no-repeat center
        background-size 100% 100%
.warn
    width 284px
    height 224px
    border-radius 5px
    box-sizing border-box
    position relative
    background url('~images/map/task-bg.png') no-repeat center
    background-size 100% 100%
//   transform translate(-52%, -192%)
    z-index 400
    :before
        content ''
        transform translate(-35%,0)
        position absolute
        bottom -9px
        left 50%
        opacity 1
        border-top solid 10px rgba(51,51,51,0.7)
        border-right solid 10px transparent
        border-left solid 10px transparent
.list-box
    overflow-y auto
    max-height 170px
    &::-webkit-scrollbar
        width 3px
        height 3px
    &::-webkit-scrollbar-thumb
        border-radius 3px
        -webkit-box-shadow inset 0 0 5px rgba(0,0,0,0.2);
        background #0f4c83
    &::-webkit-scrollbar-track
        background transparent
.list-li
    font-size 14px
    padding-left 20px
    margin-top 6px
    .point
        display inline-block
        width 6px
        height 6px
        background-color #fff
        border-radius 50%
        margin-right 4px
    .num
        font-size 22px
        color #00f8fa
        margin-right 10px
.title
    width 254px
    height 40px
    line-height 40px
    padding-left 10px
    font-size 16px
    background url('~images/map/task-title-bg.png') no-repeat center
    background-size 100% 100%
    display -webkit-box
    -webkit-box-orient vertical
    -webkit-line-clamp 1
    overflow hidden
</style>
